import StepLogo from "assets/STEPLogo.png";
import TAFLogo from "assets/taf.png";
import VoltaLogo from "assets/Volta-Research-Orange-01.png";

import "./style.scss";

const PageLayout = ({ children, pageTitle, pageWarning, pageSubtitle }) => {
    return (
        <div className="page-layout-container ">
            <div className="page-layout-wrapper">
                <h2 className="page-layout-header">{pageTitle}</h2>
                {pageWarning && <p className="page-layout-warning">{pageWarning}</p>}
                {pageSubtitle && <p className="page-layout-subtitle">{pageSubtitle}</p>}
                <hr
                    style={{
                        margin: "1.5rem 0",
                        border: "0",
                        borderTop: "1px solid rgba(0, 0, 0, .1)",
                    }}
                />
                <div className="page-layout-body">{children}</div>
                <hr
                    style={{
                        margin: "1.5rem 0",
                        border: "0",
                        borderTop: "1px solid rgba(0, 0, 0, .1)",
                    }}
                />
                <footer className="page-layout-footer">
                    <p style={{ marginBottom: "1rem" }}>
                        © Copyright 2026 Toronto and Region Conservation Authority (TRCA) | All Rights Reserved <br />
                        Version: 2.0
                    </p>
                    <a href="https://www.sustainabletechnologies.ca" target="_blank" rel="noopener noreferrer">
                        <img src={StepLogo} alt="Step Logo" />
                    </a>
                    <p style={{ marginBottom: "1rem" }}>
                        <br />
                        Financial support provided by:
                    </p>
                    <a href="https://taf.ca" target="_blank" rel="noopener noreferrer">
                        <img src={TAFLogo} alt="TAF Logo" style={{ width: "130px", height: "auto" }} />
                    </a>
                    <p style={{ marginBottom: "1rem" }}>
                        <br />
                        Created in collaboration with:
                    </p>
                    <a href="https://voltaresearch.org" target="_blank" rel="noopener noreferrer">
                        <img src={VoltaLogo} alt="Volta Research Logo" style={{ width: "130px", height: "auto" }} />
                    </a>
                </footer>
            </div>
        </div>
    );
};

export default PageLayout;
